import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';

import Button from '../../components/Button';
import './styles.css';

const messages = defineMessages({
  footerText: {
    id: 'community.availabilitySidebar.footer.text',
    defaultMessage: 'Not ready to schedule a visit yet?',
  },
  buttonText: {
    id: 'community.availabilitySidebar.footer.button',
    defaultMessage: 'Add school to travel plan',
  },
});
export const TravelPlanFooterComponent = ({ addToTravelPlanHandler }) => (
  <div styleName="footer">
    <p>
      <FormattedMessage {...messages.footerText} />
      <Button styleName="footer-button" onClick={addToTravelPlanHandler}>
        <FormattedMessage {...messages.buttonText} />
      </Button>
    </p>
  </div>
);
TravelPlanFooterComponent.propTypes = {
  addToTravelPlanHandler: PropTypes.func.isRequired,
};

export default TravelPlanFooterComponent;
